import {styled, emotionStyled, tokens} from '@packages/utilities/styled';
import {NewTabLarge, VideoButton} from '@packages/systems/ui/icons';

export const NewTabIcon = styled(NewTabLarge)(({theme}) => ({
  marginLeft: '5px',
  marginRight: '5px',
  height: '10px',
  width: '11px',
  color: theme.colors.foregroundDim,
  display: 'inline-block',
}));

export const VideoPlayIcon = styled(VideoButton)(({theme}) => ({
  height: '48px',
  width: '48px',
  color: theme.colors.white,
  opacity: '0.9',
}));

export const StyledBackgroundVideoInfoText = emotionStyled('div')({
  marginTop: '5px',
});

export const StyledCenteredSettingsText = emotionStyled('div')({
  textAlign: 'center',
  color: '$textSecondary',
});

export const StyledSettingsText = emotionStyled('div')({
  marginTop: '3px',
  color: '$textSecondary',
});

export const StyledSettingsFileText = emotionStyled('span')({
  color: '$textSecondary',
});

export const StyledSettingsProgress = emotionStyled('div')({
  position: 'absolute',
  height: '60%',
  width: '100%',
  top: '0',
  bottom: '0',
  margin: 'auto',
});

export const StyledSettingsProgressText = emotionStyled('div')({
  fontSize: '16px',
  textAlign: 'center',
  marginBottom: '12px',
});

export const StyledVideoProgressBar = emotionStyled('div')({
  height: '8px',
  width: '80%',
  margin: 'auto',
  borderRadius: '100px',
  background: tokens.colors.background4,
  border: `1px solid ${tokens.colors.background4}`,
  marginBottom: '12px',
});

export const StyledVideoProgressBarFill = emotionStyled('div')({
  height: '100%',
  background: tokens.colors.greenText,
  borderRadius: '100px',
  transition: 'width 200ms ease',
});

export const StyledVideoProgressBarFillBlue = emotionStyled('div')({
  height: '100%',
  background: '#4e86c9',
  borderRadius: '100px',
  transition: 'width 200ms ease',
});

export const StyledPreviewVideoWrapper = emotionStyled('div')({
  background: '#363636',
  border: `1px solid ${tokens.colors.background4}`,
  borderRadius: '2px',
  fontSize: '11px',
  margin: '8px 0',
  minHeight: '120px',
  position: 'relative',
});

export const StyledVideo = emotionStyled('video')({
  maxWidth: '100%',
});

export const StyledUploadInput = emotionStyled('input')({
  position: 'absolute',
  width: '100%',
  height: '100%',
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
  opacity: 0,
  cursor: 'default',
});

export const StyledPlayMask = emotionStyled('div')(
  {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  {
    variants: {
      hover: {
        true: {
          opacity: 0,
        },
      },
    },
  }
);
